import React, { memo } from 'react';
import moment from 'moment-timezone';
import Table from '../../Table';

interface Props {
  intl?: { formatMessage },
  applicantHistories?: [{
    action,
    timestamp,
    ipAddress,
    otpAuthTime,
  }]
}



const ApplicantTimestamp: React.FC<Props> = ({ intl: { formatMessage }, applicantHistories }): JSX.Element =>{

  const  sortDay = () => {
    if(!applicantHistories){
      return []
    }
    let histories = [...applicantHistories];

    histories.sort((a, b) => {
      if (a.timestamp && !b.timestamp) {
        return -1;
      } else if (!a.timestamp && b.timestamp) {
        return 1;
      }
      return   b.timestamp - a.timestamp;
    });
    return histories;
  }

  return(
  <section>
    { /* <Button
      isSecondary
      isDisabled
      value={(
        <small>
          {formatMessage({ id: 'dashboard.updateApp.extractExcel' })}
          {' '}
          &nbsp;
          {' '}
          <span><img src={IconExcel} alt="Markaz excel icon" /></span>
        </small>
      )}
    /> */ }
    <Table isWithBorder>
      <Table.Header>
        <tr>
          {[formatMessage({ id: 'dashboard.updateApp.events' }),
            formatMessage({ id: 'dashboard.updateApp.timestamp' }),
            formatMessage({ id: 'dashboard.updateApp.ipAddress' }),
            formatMessage({ id: 'dashboard.updateApp.OTPAuthentication' }),
          ].map((item, idx) => (<th key={idx}>{item}</th>))}
        </tr>
      </Table.Header>
      <Table.Body>
        {sortDay().map((item, idx) => (
          <tr key={idx}>
            <td>{item.action ? formatMessage({ id: item.action }) : ''}</td>
            <td>{item.timestamp ? moment(item.timestamp).tz('Asia/Kuwait').format('DD/MM/YYYY HH:mm:ss') : ''}</td>
            <td>{item.ipAddress || ''}</td>
            <td>{item.otpAuthTime ? moment(item.otpAuthTime).tz('Asia/Kuwait').format('DD/MM/YYYY HH:mm:ss') : ''}</td>
          </tr>
        ))}
      </Table.Body>
    </Table>
  </section>
)
};

export default memo(ApplicantTimestamp);
